
import { IdfStandardInputs, IdfInput } from '@invivodf/ui-kit'
import { PropType } from 'vue'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { DiscountScopes } from '@invivodf/module-discount-sdk'
import { IUseDiscountInput } from '../../composables/useDiscountInput'
import { useFormErrors } from '../../composables/useFormErrors'

export default {
  name: 'CDiscountPublicNameInput',
  components: { IdfInput, IdfStandardInputs },
  props: {
    input: {
      type: Object as PropType<IUseDiscountInput>,
      required: true,
    },
    discountScope: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { translateError } = useFormErrors()
    const i18n = useI18nForVue2()

    const publicNameMessage =
      props.discountScope === DiscountScopes.Mixed_group
        ? i18n.t(`ctx.discount.form.public-name-message.${props.discountScope}`).toString()
        : i18n.t(`ctx.discount.form.public-name-message.default`).toString()

    return { translateError, publicNameMessage }
  },
}
